const planPeriodicities = [
  {
    code: 'monthly',
    label: 'Mensal',
  },
  {
    code: 'quarterly',
    label: 'Trimestral',
  },
  {
    code: 'semiannually',
    label: 'Semestral',
  },
]

export default planPeriodicities
